import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import DemoIndex from '@/pages/demoIndex'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'DemoIndex',
    component: DemoIndex
  }, {
    path: '/res',
    name: 'index',
    component: Index
  }, {
    path: '/demo',
    name: 'DemoIndex',
    component: DemoIndex
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js